﻿import {marked} from "marked";
import {HTMLAttributes, JSX, Ref, useMemo} from "react";

export interface MarkdownProps extends HTMLAttributes<HTMLDivElement> {
	markdown: string;
	ref?: Ref<HTMLDivElement>;
}

export default function Markdown(props: MarkdownProps): JSX.Element {
	const {markdown, className, ...rest} = props;
	const innerHtml = useMemo(() => {
		const rawHtml = marked(markdown, {async: false}).replace(/<a /g, "<a target=\"_blank\" rel=\"noopener noreferrer\" ");
		return {__html: rawHtml};
	}, [markdown]);

	const klass = "markdown" + (className ? " " + className : "");
	return <div className={klass} dangerouslySetInnerHTML={innerHtml} {...rest} />;
}
